import { setupFormState } from '@/components/form/tidal-form'
import { TrafficTimeWindows } from './types'

export const form = setupFormState<TrafficTimeWindows>({
  id: 'trafficWindow',
  initialValues: { timeWindows: [] },
})
